import React from 'react';

import {
  formatPrice,
} from 'common/formatters';

import {
  BUTTON_THEME_GREY_ADOBE,
  BUTTON_THEME_RED_ADOBE,
} from 'client/components/ButtonDeprecated';
import SrText from 'client/components/SrText';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';

const SrListingRequestWithdrawnAlertModal = ({
  partner,
  onSubmit,
  onClose,
}) => {
  const withdrawalFeeFormatted = formatPrice(partner.withdrawalFee);

  return (
    <SrSimpleMessageModal
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      maxWidth='375'
      iconUrl='/images/warnin-icon-dolars-red.svg'
      headline={`There is a withdraw fee of ${withdrawalFeeFormatted}. Are you sure you want to withdraw?`}
      underline
      message={
        <SrText weight='600' font='greycliff' lineHeight='25px'>
          Sunroom charges a {withdrawalFeeFormatted} withdraw fee for any listing withdrawn
          after Sunroom touches the property, or the listing is activated.
          If you have questions, please call your dedicated Account Manager
        </SrText>
      }
      multiButtons={[
        {
          buttonText: 'Request withdrawal',
          onButtonClick: onSubmit,
          buttonTheme: BUTTON_THEME_RED_ADOBE,
        },
        {
          buttonText: 'Cancel',
          onButtonClick: onClose,
          buttonTheme: BUTTON_THEME_GREY_ADOBE,
        },
      ]}
    />
  );
};

SrListingRequestWithdrawnAlertModal.displayName = 'SrListingRequestWithdrawnAlertModal';

export default SrListingRequestWithdrawnAlertModal;
